import { createAsyncThunk } from '@reduxjs/toolkit'
import { Api, ApiMethod } from '../../../utils/Api'
import { processParams } from '../../../utils/LazyParamsUtil'
import { Resume } from './interface'

const jobEndpoint = process.env.REACT_APP_JOB_API_URL

export const downloadResumeForAdmin = createAsyncThunk('resume/downloadResume',
  async (resumeId: number, { rejectWithValue }) => 
    Api(ApiMethod.GET, jobEndpoint, "download-resume/" + resumeId, {}, rejectWithValue)
)

export const retrieveResumes = createAsyncThunk('resume/retrieveResumes',
  async (lazyParams: any, { rejectWithValue }) => Api(ApiMethod.GET, jobEndpoint, 'resumes', processParams(lazyParams), rejectWithValue)
)

export const retrieveResume = createAsyncThunk('resume/retrieveResume',
  async (resumeId: number, { rejectWithValue }) => Api(ApiMethod.GET, jobEndpoint, 'resume/' + resumeId, undefined, rejectWithValue)
)

export const compareResumes = createAsyncThunk('resume/compareResumes',
  async ({resumeId1, resumeId2}: {resumeId1: number, resumeId2: number}, { rejectWithValue }) => 
    Api(ApiMethod.GET, jobEndpoint, 'resume/compare/' + resumeId1 + '/' + resumeId2, undefined, rejectWithValue)
)

export const updateResume = createAsyncThunk('resume/updateResume',
  async (resume: Resume, { rejectWithValue }) => Api(ApiMethod.PUT, jobEndpoint, 'resume', resume, rejectWithValue)
)

export const uploadResumes = createAsyncThunk('resume/uploadResumes',
  async (resumeData: FormData, { rejectWithValue }) => Api(ApiMethod.POST, jobEndpoint, 'upload-resume', resumeData, rejectWithValue)
)

export const retrieveResumeUploads = createAsyncThunk('resume/retrieveResumeUploads',
  async (lazyParams: any, { rejectWithValue }) => Api(ApiMethod.GET, jobEndpoint, 'resume/uploads', processParams(lazyParams), rejectWithValue)
)